<template>
  <div>
    <vs-row class="mb-3" >
      <vs-button color="dark" disabled type="flat"><h5>Setting  /  Setup Work Requests</h5></vs-button>
    </vs-row>
         <!-- <b-breadcrumb style="background-color: #ffffff; padding-left: 0px; ">
    <b-breadcrumb-item active><h5>Manage Work</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Work Requests</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
  <vs-row vs-w="12">
  <vs-card style="border-radius: 20px;">
      <div class="mt-2 mb-2"  >
        <vs-row id="center">
          <h3  id="p" style="color: #111111">
            Setup and Configure Work Requests
          </h3>
        <vs-spacer />
        <!-- <vs-tooltip  text="Download a PDF" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="exportPDF" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>
          <vs-tooltip  text="Export" position="top" >
          <vs-button  class="mr-2"  radius @click="onExport" color="#333f50" type="line"  icon="cloud_download"></vs-button></vs-tooltip>
          <vs-tooltip  text="Add New Sensor" position="top" >
            <h6> <vs-button color="success"  style="border-radius: 20px;" size="sm" icon="add" v-b-modal.addsensor type="filled">Add Sensor</vs-button></h6>
        </vs-tooltip> -->
        </vs-row>
    </div>
     
      <vs-table max-items="8" pagination search :data="users">
    
      <template slot="thead">
        <vs-th >
          
        </vs-th>
        <vs-th sort-key="email">
            <span><vs-icon icon="unfold_more" size="16px" ></vs-icon></span>
          Name
        </vs-th>
        <vs-th >
          Work Request Portal URL (no login needed)
        </vs-th>
        <vs-th >
          Configuration
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td>
            <vs-button class="mr-2" radius color="dark" type="line" icon="dashboard" v-b-modal.modal-1 @click="a=data[indextr]" ></vs-button>
          </vs-td>
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}}
          </vs-td>

          <vs-td :data="data[indextr].username">
            <a href="djhvfihrjiofj">https://app.com/#!/loc-problem/7eagz3465/7619</a>
              <!-- <div style="display: flex;
  align-items: center;">
   <vs-button class="mr-2" radius color="dark" type="line" icon="dashboard" v-b-modal.modal-1 @click="a=data[indextr]" ></vs-button>
                  <a href="djhvfihrjiofj">https://app.com/#!/loc-problem/7eagz3465/7619</a>
           
              </div> -->
            
          </vs-td>

          <vs-td >
            <a  v-b-modal.modal-2 @click="a=data[indextr]" >Customize</a>
          </vs-td>
        </vs-tr>
      </template>
   

    </vs-table>
    <b-modal id="modal-1" size="lg" scrollable title="Submit a Request for Global">
    <p class="my-4">Use the QR Codes to lookup the URL for a given Location to submit a Work Request.</p>
    <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="space-around" vs-w="12">
  <vs-col  vs-type="flex" vs-justify="center" vs-align="center" >
    <vs-button id="btnmodal" class="ml-2" color="warning" type="filled" icon="get_app">Download Image</vs-button>
    <vs-button id="btnmodal" class="ml-2" color="primary" type="filled" icon="print">Print</vs-button>
  </vs-col>
  
</vs-row>
    <!-- {{a}} -->
    <div class="mt-3" align="center">
            <img  src="../../../assets/images/QR.png" style="width: 40%; "/><br>
            <h4>{{a.name}}</h4>
          </div>
     <template #modal-footer="{ cancel }">
      <b-button id="btncancel"  variant="light" @click="cancel()">Close</b-button>
    </template>
  </b-modal>


  <!-- Madal Customize -->
  <b-modal id="modal-2" size="lg" scrollable title="Customize the Work Request ">
    <p class="my-4">Work Requests are assigned to : <b>{{a.name}}</b></p>
    
     <template #modal-footer="{ cancel }">
      <b-button id="btncancel"  variant="light" @click="cancel()">Close</b-button>
    </template>
  </b-modal>
  </vs-card>
</vs-row>
 
    </div>
</template>

<script>
export default {
  name: 'WorkRequests',
   data:()=>({
     a:'',
    users:[
      {
        "id": 1,
        "name": "Leanne Graham",
        "username": "Bret",
        "email": "Sincere@april.biz",
        "website": "hildegard.org",
      },
      {
        "id": 2,
        "name": "Ervin Howell",
        "username": "Antonette",
        "email": "Shanna@melissa.tv",
        "website": "anastasia.net",
      },
      {
        "id": 3,
        "name": "Clementine Bauch",
        "username": "Samantha",
        "email": "Nathan@yesenia.net",
        "website": "ramiro.info",
      },
      {
        "id": 4,
        "name": "Patricia Lebsack",
        "username": "Karianne",
        "email": "Julianne.OConner@kory.org",
        "website": "kale.biz",
      },
      {
        "id": 5,
        "name": "Chelsey Dietrich",
        "username": "Kamren",
        "email": "Lucio_Hettinger@annie.ca",
        "website": "demarco.info",
      },
      {
        "id": 6,
        "name": "Mrs. Dennis Schulist",
        "username": "Leopoldo_Corkery",
        "email": "Karley_Dach@jasper.info",
        "website": "ola.org",
      },
      {
        "id": 7,
        "name": "Kurtis Weissnat",
        "username": "Elwyn.Skiles",
        "email": "Telly.Hoeger@billy.biz",
        "website": "elvis.io",
      },
      {
        "id": 8,
        "name": "Nicholas Runolfsdottir V",
        "username": "Maxime_Nienow",
        "email": "Sherwood@rosamond.me",
        "website": "jacynthe.com",
      },
      {
        "id": 9,
        "name": "Glenna Reichert",
        "username": "Delphine",
        "email": "Chaim_McDermott@dana.io",
        "website": "conrad.com",
      },
      {
        "id": 10,
        "name": "Clementina DuBuque",
        "username": "Moriah.Stanton",
        "email": "Rey.Padberg@karina.biz",
        "website": "ambrose.net",
      }
    ]
  })
}
</script>
<style  scoped>

th .sort-th .th-sort-icon {
   
    color: white;
}
#btnmodal{
  border-radius: 100px;
}
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
</style>